export const LABEL_REG_EXP =
  /^[a-zA-Z][a-zA-Z0-9[\]\\/?.,;:|*~`!^\\_+<>@#$%&='(){}\\-]*$/

export const NUMBER_REG_EXP = /^[0-9]+$/
export const PIN_REG_EXP = /^\d{6,8}$/
export const CODE_REG_EXP = /^\d{6}$/
export const EMAIL_VALID_REG_EXP =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i
export const PASSWORD_REG_EXP = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,128}$/
export const RECOVERY_CODE_REG_EXP = /^[a-f0-9]{6}-[a-f0-9]{6}$/

export const PUBLIC_URL_REG_EXP =
  /^(?!.*\/dashboard)(.*\/(hublink|campaign|promotion))/
